module.exports = __webpack_public_path__ + "img/slot_slide_blockers.d874f376.png";